import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum PalliativeRacesEnum {
    none = 0 as number,
    AmericanIndianOrAlaskaNative = 1 as number,
    Asian = 2 as number,
    BlackOrAfricanAmerican = 4 as number,
    NativeHawaiianOrOtherPacificIslander = 16 as number,
    White = 32 as number,
    OtherRace = 256 as number
}
class PalliativeRacesClass extends EnumWithDescription<PalliativeRacesEnum> {
    public readonly enum = PalliativeRacesEnum;
    public readonly enumName: string = "PalliativeRacesEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PalliativeRacesEnum>> = new Map([
        [
            "AmericanIndianOrAlaskaNative",
            {
                value: PalliativeRacesEnum.AmericanIndianOrAlaskaNative,
                name: "American Indian or Alaska Native"
            }
        ],
        [
            "Asian",
            {
                value: PalliativeRacesEnum.Asian,
                name: "Asian"
            }
        ],
        [
            "BlackOrAfricanAmerican",
            {
                value: PalliativeRacesEnum.BlackOrAfricanAmerican,
                name: "Black or African American"
            }
        ],
        [
            "NativeHawaiianOrOtherPacificIslander",
            {
                value: PalliativeRacesEnum.NativeHawaiianOrOtherPacificIslander,
                name: "Native Hawaiian or Other Pacific Islander"
            }
        ],
        [
            "White",
            {
                value: PalliativeRacesEnum.White,
                name: "White"
            }
        ],
        [
            "OtherRace",
            {
                value: PalliativeRacesEnum.OtherRace,
                name: "Other Race"
            }
        ]
    ]);
}

export const RacesPalliative = new PalliativeRacesClass();
